import React, { useState, useCallback } from "react";
import { InputText } from "@silversea-ssc/ui-components-react";
import { useSearchBox } from "react-instantsearch";

interface SearchBarProps {
  placeholder: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ placeholder }) => {
  const { query, refine } = useSearchBox();
  const [inputValue, setInputValue] = useState(query);

  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const newQuery = event.currentTarget.value;
      setInputValue(newQuery);
      refine(newQuery);
    },
    [refine]
  );

  // Track when the InstantSearch query changes to synchronize it with
  // the React state.
  // We bypass the state update if the input is focused to avoid concurrent
  // updates when typing.
  const isFocus = document.activeElement?.getAttribute("name") == "query";
  if (query !== inputValue && !isFocus) {
    setInputValue(query);
  }

  return (
    <InputText
      size="big"
      name="query"
      placeholder={placeholder}
      value={inputValue}
      onChange={onChange}
    />
  );
};

export default SearchBar;
